module.exports = __webpack_public_path__ + "img/toni_dumancic.ef8678f5.jpg";